import './App.css';
import SlIcon from '@shoelace-style/shoelace/dist/react/icon/index.js';
import SlDialog from '@shoelace-style/shoelace/dist/react/dialog/index.js';
import SlButton from '@shoelace-style/shoelace/dist/react/button/index.js';
import SlTooltip from '@shoelace-style/shoelace/dist/react/tooltip/index.js';
import SlBadge from '@shoelace-style/shoelace/dist/react/badge/index.js';
import { CDSUiIcons } from '@cencora-design-system/assets/icons';
import { CDSIconWeight, CDSIconSize } from '@cencora-design-system/assets/icons';
import { useEffect, useRef, useState } from 'react';
import LatestChange from './LatestChange';
import DislikeModal from './DislikeModal';
import Filters from './Filters';
import Search from './Search';
import ViewDetails from './ViewDetails';
import ResultPagination from './ResultPagination';
import UserPreference from './UserPreference';
import { BrowserRouter, Routes, Route, useNavigate, Link } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import { useApi } from './useApi';



function App() {
  return (
    <AuthProvider>
      <AuthenticatedApp />
    </AuthProvider>
  );
}

function AuthenticatedApp() {
  const { isAuthenticated, isLoading, userName, userId, logout } = useAuth();
  const [showPopup, setShowPopup] = useState(false);
  const [isDisliked, setIsDisliked] = useState(false);
  const [dislikedCardId, setDislikedCardId] = useState(null);
  const [cardData, setcardData] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [onDislikeSubmitCallback, setOnDislikeSubmitCallback] = useState(null);
  const [feedbackMessage, setFeedbackMessage] = useState(null);

  // Show loading screen while authenticating or redirecting to login
  if (isLoading || !isAuthenticated) {
    return (
      <div className="auth-loading">
        <div className="auth-loading-content">
          <p>{isLoading ?  'Redirecting to login...' : 'Authenticating...'}</p>
        </div>
      </div>
    );
  }

  function handleCardDislike(cardData) {
    setcardData(cardData);
    setDislikedCardId(cardData.cardId);
  }

  function onDislike() {
    setIsDisliked(!isDisliked);
  }

  {/* dislike logic */ }
  function handleDislikeClick(cardData) {
    setSelectedCard(cardData);
    // Store the callback to update card state after submission
    if (cardData.onDislikeSubmit) {
      setOnDislikeSubmitCallback(() => cardData.onDislikeSubmit);
    }
    setIsModalOpen(true);
  }

  function handleCloseModal() {
    setIsModalOpen(false);
    setSelectedCard(null);
    setOnDislikeSubmitCallback(null);
  }

  function handleSubmitFeedback(data) {
    console.log("Card :", selectedCard);
    console.log("Feedback:", data);
    // Call the callback to update card's local state
    if (onDislikeSubmitCallback) {
      onDislikeSubmitCallback();
    }
    handleCloseModal();
    setFeedbackMessage("User's feedback updated");
    setTimeout(() => setFeedbackMessage(null), 4000);
  }

  return (
    <BrowserRouter>
    <Header userName={userName} setShowPopup={setShowPopup} logout={logout} />
      <Popup open={showPopup} onClose={() => setShowPopup(false)} />
      <DislikeModal open={isModalOpen} onClose={handleCloseModal} onSubmit={handleSubmitFeedback} articleData={selectedCard} userId={userId} />
      <Routes>
      <Route path="/" element={<MainPage onDislikeClick={handleDislikeClick} dislikedCard={dislikedCardId} handleCardDislike={handleCardDislike} onDislike={onDislike} isDisliked={isDisliked} feedbackMessage={feedbackMessage} userId={userId} />} />
      <Route path="/details/:id" element={<ViewDetails userId={userId} />} />
      <Route path="/preferences" element={<UserPreference userId={userId} />} />
      </Routes>
    </BrowserRouter>
      
  );
}

function Header({ userName, setShowPopup, logout }) {
  const navigate = useNavigate();

  function handleHomeClick() {
    if (window.location.pathname === '/') {
      // Already on home page, scroll content and sidebar to top
      const contentElement = document.querySelector('.content');
      if (contentElement) {
        contentElement.scrollTo({ top: 0, behavior: 'smooth' });
      }
      const sidebarElement = document.querySelector('.sidebar');
      if (sidebarElement) {
        sidebarElement.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } else {
      // Navigate to home, retaining filters, search, and other state
      navigate('/');
    }
  }

  return (<div className="header">
    <div className="header-left">
      <img src="/Logo/Cencora_Logo_Primary.svg" alt="logo" className="logo" />
      <span className="home-text">RI Digest</span>
    </div>
    <div className="header-right">
      <span className="header-icon" onClick={handleHomeClick}><SlIcon
        src={CDSUiIcons.IconHouseChimney2}
        size={CDSIconSize.size_4xl}
        weight={CDSIconWeight.medium}
        label="Home">
      </SlIcon></span>
      <span className="header-icon" onClick={() => setShowPopup(true)}><SlIcon
        src={CDSUiIcons.IconQuestionCircle}
        size={CDSIconSize.size_4xl}
        weight={CDSIconWeight.medium}
        label="Icon example">
      </SlIcon></span>
      <UserProfile userName={userName} logout={logout} />
    </div>

  </div>);
}

function UserProfile({ userName, logout }) {
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    function handleClickOutside(e) {
      console.log("ref:", ref.current);
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  function getInitials(userName) {
    // Handle null/undefined userName
    if (!userName) return '?';
    // Trim the name and split into words, handling punctuation
    const words = userName.trim().split(/\s+/);
    // If there are no words, return a placeholder
    if (words.length === 0 || !words[0]) return '?';
    // Extract the first letter of the first two words
    const initials = words.slice(0, 2).map((word) => word[0]?.toUpperCase() || '');
    // Join the initials into a single string
    return initials.join('') || '?';
  }

  function handleManageAccount() {
    setOpen(false);
    navigate('/preferences');
  }

  function handleSignOut() {
    setOpen(false);
    if (logout) {
      logout();
    }
  }

  return <div ref={ref} className="profile-wrapper" onClick={() => setOpen(!open)}>
    <span className="profile-icon">{getInitials(userName)}</span>
    <SlIcon 
      src="/Icons/chevron-down.svg"
      style={{ width: '18px', height: '18px' }}
    />
    {open && (<div className="dropdown">
      <Link to="/preferences" className="dropdown-item" onClick={() => setOpen(false)}>Manage Account</Link>
      <div className="dropdown-item" onClick={handleSignOut}>Sign Out</div>
    </div>)}
  </div>
}

function Popup({ onClose, open }) {
  const supportEmail = "aicoe@cencora.com";
  const [tooltipText, setTooltipText] = useState("Copy Email ID");

  function copyToClipboard(email, e) {
    e.stopPropagation();
    navigator.clipboard.writeText(email);
    setTooltipText("Email copied");
  }

  function resetTooltip() {
    setTooltipText("Copy Email ID");
  }

  function handleDialogClose(e) {
    // Only close if the event is from the dialog itself, not from nested components
    if (e.target.tagName === 'SL-DIALOG') {
      onClose();
    }
  }

  return (
    <SlDialog
      className="support-dialog"
      open={open}
      onSlAfterHide={handleDialogClose}
    >
      <span slot="label" className="dialog-label-with-icon">
        <SlIcon
          src={CDSUiIcons.IconQuestionCircle}
          size={CDSIconSize.size_4xl}
          weight={CDSIconWeight.medium}
        />
        Support and Assistance Hub
      </span>
      <div className="modal-body">
        <p>We're here to help with any requests and changes you need. Please use our ServiceNow portal to manage your keywords and clients. Click the button below to proceed:</p>
        <p>For further assistance, please reach out to our support team.</p>
        <div className="support-email-wrapper">
          <span className="support-email">{supportEmail}</span>
          <SlTooltip content={tooltipText} hoist>
            <img className="clipboard-icon" src="/Support_Modal/Copy_Paste.svg" alt="Copy email to clipboard" onClick={(e) => copyToClipboard(supportEmail, e)} onMouseEnter={resetTooltip} />
          </SlTooltip>
        </div>
      </div>
      <div className="cds-dialog-footer-layout" slot="footer">
        <SlButton variant="primary" onClick={() => window.open('https://cencora.service-now.com', '_blank')}>
          Service Request
        </SlButton>
      </div>
    </SlDialog>
  );
}

function MainPage({ onDislikeClick, dislikedCard, handleCardDislike, onDislike, isDisliked, feedbackMessage, userId }) {
  const { authGet, authPost } = useApi();
  const timelineFilters = {
    "extractedTime": [
      { "value": 0, "label": "All days" },
      { "value": 7, "label": "Last 7 days" },
      { "value": 15, "label": "Last 15 days" },
      { "value": 30, "label": "Last 30 days" },
      { "value": 60, "label": "Last 60 days" },
      { "value": 180, "label": "Last 180 days" }
    ],
    "updateTime": [
      { "value": 0, "label": "All days" },
      { "value": 7, "label": "Last 7 days" },
      { "value": 15, "label": "Last 15 days" },
      { "value": 30, "label": "Last 30 days" },
      { "value": 60, "label": "Last 60 days" },
      { "value": 180, "label": "Last 180 days" }
    ]
  };

  // Restore state from sessionStorage on mount
  const savedPage = sessionStorage.getItem('page');
  const savedSearchTerm = sessionStorage.getItem('searchTerm');
  const savedFilters = sessionStorage.getItem('selectedFilters');

  const [filtersData, setFiltersData] = useState(timelineFilters);
  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const defaultFilters = {
    extractedTime: [0],
    updateTime: [0]
  };
  // Initialize with saved filters if available, otherwise default filters
  const [selectedFilters, setSelectedFilters] = useState(
    savedFilters ? JSON.parse(savedFilters) : defaultFilters
  );
  const [pageData, setPageData] = useState({
    total: 0,
    page: 1,
    pageSize: 10,
    hasNext: false
  });
  const [page, setPage] = useState(savedPage ? parseInt(savedPage, 10) : 1);
  const [searchTerm, setSearchTerm] = useState(savedSearchTerm || "");
  const [sortOrder, setSortOrder] = useState(sessionStorage.getItem('sortOrder') || "DESC");
  const [latestUpdatesResult, setLatestUpdatesResult] = useState({
    items:[],
    page:0,
    totalPages:0
  });
  const [latestPage, setLatestPage] = useState(1);
  const pageSize = 20; // Set a default page size for latest updates
  const [loadingNextPage, setLoadingNextPage] = useState(false);
  const[latestLoading, setLatestLoading] = useState(false);
  
  // Persist pagination and search state to sessionStorage (not filters)
  useEffect(() => {
    sessionStorage.setItem('page', page.toString());
  }, [page]);

  useEffect(() => {
    sessionStorage.setItem('searchTerm', searchTerm);
  }, [searchTerm]);

  useEffect(() => {
    sessionStorage.setItem('sortOrder', sortOrder);
  }, [sortOrder]);

  // Persist filters to sessionStorage
  useEffect(() => {
    sessionStorage.setItem('selectedFilters', JSON.stringify(selectedFilters));
  }, [selectedFilters]);

  // Clean up selectedFilters to only include values that exist in available filtersData
  // This prevents stale values from showing incorrect counts in breadcrumbs
  useEffect(() => {
    const cleanedFilters = { ...selectedFilters };
    let hasChanges = false;

    Object.keys(cleanedFilters).forEach(filterKey => {
      // Skip time filters as they use predefined values
      if (filterKey === 'extractedTime' || filterKey === 'updateTime') return;
      
      const availableOptions = filtersData[filterKey];
      if (availableOptions && Array.isArray(cleanedFilters[filterKey])) {
        const availableValues = availableOptions.map(opt => opt.value);
        const filteredValues = cleanedFilters[filterKey].filter(val => availableValues.includes(val));
        
        if (filteredValues.length !== cleanedFilters[filterKey].length) {
          cleanedFilters[filterKey] = filteredValues;
          hasChanges = true;
        }
      }
    });

    if (hasChanges) {
      setSelectedFilters(cleanedFilters);
    }
  }, [filtersData]); // eslint-disable-line react-hooks/exhaustive-deps

  // API URL from build-time environment variable (fallback to dev for local development)
  const apiBaseUrl = process.env.REACT_APP_API_URL;
  const api = `${apiBaseUrl}/records`;
  const latestUpdatesApi = `${apiBaseUrl}/records/latest-updates`;
  const userPreferenceApi = `${apiBaseUrl}/userpreferences`;
  
  

  //initial loading - fetch user preferences only if no saved filters
  useEffect(() => {
    fetchLatestUpdates();
    // If we have saved filters from sessionStorage, use them directly
    if (savedFilters) {
      // Filters already set from sessionStorage, just fetch data
      // The useEffect watching selectedFilters will trigger the data fetch
    } else {
      // No saved filters, fetch user preferences
      fetchUserPreferencesAndData();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Always fetch user preferences from backend and apply them
  async function fetchUserPreferencesAndData() {
    try {
      const response = await authGet(`${userPreferenceApi}`);
      if (response.ok) {
        const data = await response.json();
        console.log("User preferences loaded:", data);
        
        const preferencesFilters = {
          ...defaultFilters,
          categories: data.preferredCategories || [],
          regions: data.preferredRegions || [],
          sourceNames: data.preferredSourcesNames || []
        };
        
        // Check if user has any preferences set
        const hasPreferences = 
          (data.preferredCategories?.length > 0) ||
          (data.preferredRegions?.length > 0) ||
          (data.preferredSourcesNames?.length > 0);
        
        if (hasPreferences) {
          console.log("Applying user preferences to filters:", preferencesFilters);
          setSelectedFilters(preferencesFilters);
          // fetchFilteredData will be triggered by the useEffect watching selectedFilters
        } else {
          fetchInitialData();
        }
      } else {
        console.log("No user preferences found, loading initial data");
        fetchInitialData();
      }
    } catch (error) {
      console.error("Error fetching user preferences:", error);
      fetchInitialData();
    }
  }

  //get latest updates data
  // async function fetchLatestUpdates(){
  //   try {
  //     const response = await authGet(`${latestUpdatesApi}`);
  //     const data = await response.json();
  //     console.log("latest updates api response:", data);
  //     setLatestUpdatesResult(data);
  //   }
  //   catch (error) {
  //     console.error("Error fetchin initial data:", error);
  //   }
  // }

  async function fetchLatestUpdates(page = 1) {
    if(loadingNextPage) return; // Prevent multiple simultaneous requests
    setLoadingNextPage(true);
    if(page === 1) setLatestLoading(true); // Show loading spinner only for the first page

    try{
      const response = await authGet(`${latestUpdatesApi}?page=${page}&pageSize=${pageSize}`);
      const data = await response.json();
      console.log("latest updates api response:", data);
      setLatestUpdatesResult(prev => ({
        ...data,
        items: page === 1 ? data.items : [...prev.items, ...data.items]
      }));
    }
    finally {
      setLoadingNextPage(false);
      setLatestLoading(false);
    }
  }

  async function fetchInitialData() {
    const initialPayload = {
      "userId": userId,
      ...(selectedFilters.extractedTime?.[0] ? { "extractedDaysBack": selectedFilters.extractedTime[0] } : {}),
      ...(selectedFilters.updateTime?.[0] ? { "updatedDaysBack": selectedFilters.updateTime[0] } : {}),
      "keyword": "",
      "applyFilters": false,
      "sortOrder": sortOrder,
      "page": 1,
      "pageSize": 10
    }
    setIsLoading(true);
    try {
      const response = await authPost(api, initialPayload);
      const data = await response.json();
      console.log("initial api response:", data);
      setResults(data.items || []);
      setFiltersData(prev => ({ 
        ...data.availableFilters,
        extractedTime: prev.extractedTime,
        updateTime: prev.updateTime
      }));
      setPageData({
        total: data.total,
        page: data.page,
        pageSize: data.pageSize,
        hasNext: data.hasNext
      });
    }
    catch (error) {
      console.error("Error fetchin initial data:", error);
    }
    finally {
      setIsLoading(false);
    }
  };

  //when filters change
  useEffect(() => {
    if (Object.keys(selectedFilters).length === 0) return;

    fetchFilteredData(selectedFilters);
  }, [selectedFilters,page,searchTerm,sortOrder]);

  //Reset page to 1 when new search happens
  useEffect(() => {
    setPage(1);
  },[searchTerm,selectedFilters]);


  //API call after filter is applied
  async function fetchFilteredData(filters) {
    console.log("API call:", filters);
    const payload = {
      "userId": userId,
      "sourceName": filters.sourceNames || [],
      "categories": filters.categories || [],
      "state": filters.states || [],
      "region": filters.regions || [],
      "country": filters.countries || [],
      ...(filters.extractedTime?.[0] ? { "extractedDaysBack": filters.extractedTime[0] } : {}),
      ...(filters.updateTime?.[0] ? { "updatedDaysBack": filters.updateTime[0] } : {}),
      "keyword": searchTerm,
      "applyFilters": true,
      "sortOrder": sortOrder,
      "page": page,
      "pageSize": 10
    }
    setIsLoading(true);
    try {
      const response = await authPost(api, payload);
      const data = await response.json();
      console.log("initial api response:", data);
      setResults(data.items || []);
      setFiltersData(prev => ({ 
        ...data.availableFilters,
        extractedTime: prev.extractedTime,
        updateTime: prev.updateTime
      }));
      setPageData({
        total: data.total,
        page: data.page,
        pageSize: data.pageSize,
        hasNext: data.hasNext
      });
    }
    catch (error) {
      console.error("Error fetchin initial data:", error);
    }
    finally {
      setIsLoading(false);
    }
  }

  // Remove from breadcrumb
  function handleRemoveFilter(key, value) {
    setSelectedFilters(prev => {
      const updated = { ...prev };

      updated[key] = updated[key].filter(v => v !== value);

      if (updated[key].length === 0) {
        delete updated[key];
      }
      return updated;
    })
  }

  return <div className="page-layout">
    <div className="sidebar">
      <div className="filter-header-top">
        <SlIcon
          src="/Icons/filter-icon.svg"
        />
        <h3 className="filter-section-title">Filters</h3>
      </div>
      <Filters filtersData={filtersData} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} />
    </div>
    <div className="content">
      {feedbackMessage && (
        <div className="feedback-badge-container">
          <SlBadge className="feedback-badge" size="medium" pill>
            {feedbackMessage}
          </SlBadge>
        </div>
      )}
      <LatestChange latestLoading={latestLoading} fetchNextPage={fetchLatestUpdates} loadingNextPage={loadingNextPage} results={latestUpdatesResult} onDislikeClick={onDislikeClick} dislikedCard={dislikedCard} handleCardDislike={handleCardDislike} onDislike={onDislike} isDisliked={isDisliked} userId={userId} />
      <Search results={results} isLoading={isLoading} onDislikeClick={onDislikeClick} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} searchTerm={searchTerm} setSearchTerm={setSearchTerm} sortOrder={sortOrder} setSortOrder={setSortOrder} pageData={pageData} currentPage={page} userId={userId} />
      {!isLoading && results.length > 0 && <ResultPagination pageData={pageData} onPageChange={(newPage) => setPage(newPage)} />}
    </div>
  </div>
}

export default App;
